import React from 'react';
import { RoccoLink } from '../../../../components/link/RoccoLink';

interface FooterBottomBarProps {
    websiteTermLink: string;
    privacyPolicyLink: string;
    /** When set to US, legal links are omitted (they live in the Support accordion). */
    currentCountryCode?: string;
    onNavClick?: (link: string) => void;
}

/**
 * Bottom bar section for the new footer design.
 * Displays copyright and, outside US markets, legal links (Privacy Policy, Terms).
 */
export const FooterBottomBar: React.FC<FooterBottomBarProps> = ({
    websiteTermLink,
    privacyPolicyLink,
    currentCountryCode,
    onNavClick,
}) => {
    const currentYear = new Date().getFullYear();

    return (
        <section className="bg-[#212121] px-12 py-6">
            <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
                {/* Copyright */}
                <span className="text-sm text-white/50">
                    &copy; ArchiPro {currentYear}
                </span>

                {/* US legal links live in the Support accordion; avoid duplicating them here. */}
                {currentCountryCode !== 'US' && (
                    <div className="flex items-center gap-4">
                        <RoccoLink
                            to={privacyPolicyLink}
                            className="text-sm text-white/50 hover:text-white/80"
                            isNonRemixRoute={true}
                            onClick={() => onNavClick?.(privacyPolicyLink)}
                        >
                            Privacy Policy
                        </RoccoLink>
                        <span className="text-white/50">&middot;</span>
                        <RoccoLink
                            to={websiteTermLink}
                            className="text-sm text-white/50 hover:text-white/80"
                            isNonRemixRoute={true}
                            onClick={() => onNavClick?.(websiteTermLink)}
                        >
                            Terms
                        </RoccoLink>
                    </div>
                )}
            </div>
        </section>
    );
};
